import { AiClient, OutlineGenerationPayload } from 'api/clients/AiClient'
import { ChannelType } from 'components/CampaignCreationModal/Types'

export const generateOutline = async ({
  payload,
  signal,
}: {
  payload: OutlineGenerationPayload
  signal?: AbortSignal
}) => {
  const { generation_type } = payload.prompt
  const outlineResponse = await AiClient.generateOutline({ payload, signal })

  switch (generation_type) {
    case ChannelType.YoutubeScript:
      const items = outlineResponse
        .split('\n')
        .map((item) => item.trim())
        .filter(Boolean)
      let html = '<ol>'
      items.forEach((item) => {
        if (item.startsWith('-')) {
          // Strip the bullet point (eg. '- topic' -> 'topic')
          html += `<ul><li>${item.replace(/^-\s+/, '')}</li></ul>`
        } else {
          // Strip the roman numeral (eg. 'VI. Topic' -> 'Topic')
          html += `<li>${item.replace(/^.+\.\s+/, '')}</li>`
        }
      })
      html += '</ol>'
      html = html.replace(/<\/ul><ul>/g, '')
      return html
    case ChannelType.BlogPost:
    default:
      const h2Regex = /^\s*##\s+(.*)$/gm
      const h3Regex = /^\s*###\s+(.*)$/gm
      const outlineHtml = outlineResponse.replace(h2Regex, '<h2>$1</h2>').replace(h3Regex, '<h3>$1</h3>')
      return outlineHtml
  }
}
